
export interface Topic {
  id: number;
  isNew?: boolean;
  isWide?: boolean;
  content: string;
  contentEn?: string;
  date?: string;
  link?: string;
  keywords?: string[];
}

export const topics: Topic[] = [
  {
    id: 12,
    isNew: true,
    content: "事業性融資推進法施行令が公布\n事業性評価融資の重要性がさらに高まります",
    contentEn: "New Enforcement Order for the Business-Based Financing Act\nBusiness-viability assessment lending grows even more important",
    date: "2025/07",
    link: "https://laws.e-gov.go.jp/law/507CO0000000243",
    keywords: ["事業性評価融資", "事業性融資推進法", "企業価値担保権", "融資", "経営コンサルティング", "神戸", "兵庫"]
  },
  {
    id: 14,
    isNew: true,
    content: "セミナー・講演・勉強会のお知らせ\n開催前アンケートで参加者のニーズを把握し、完全オリジナルのレジュメを作成。最新情勢を反映し、即現場で使える内容を提供。AI初心者から熟練者まで、あらゆる階層に対応した完全オーダーメイド研修",
    contentEn: "Seminars & Workshops\nPre-event surveys capture participant needs — every session uses a fully original agenda. Content reflects the latest trends and is immediately applicable in the field. Fully custom-made for any audience, from AI beginners to advanced practitioners.",
    link: "/seminar",
    keywords: ["セミナー", "講演", "勉強会", "研修", "AI", "オーダーメイド", "神戸", "兵庫"]
  },
  {
    id: 1,
    content: "AI導入支援サポート\nAI活用で業務を変革。貴社の課題に合わせた最適なAIソリューションを提案します",
    contentEn: "AI Implementation Support\nTransform your operations with AI. We propose the best AI solution tailored to your business challenges.",
    date: "2026/01",
    link: "/ai-support",
    keywords: ["AI", "DX", "研修", "業務効率化", "神戸", "兵庫"]
  },
  {
    id: 4,
    content: "AI用語について",
    contentEn: "AI Glossary",
    link: "/ai-glossary",
    keywords: ["AI", "経営コンサルティング", "ビジネス活用", "デジタル化"]
  },
  {
    id: 5,
    content: "ビジネスで活用できるAIツール",
    contentEn: "AI Tools for Business",
    link: "/ai-tools",
    keywords: ["AI", "業務効率化", "神戸", "兵庫", "デジタルトランスフォーメーション"]
  },
  {
    id: 7,
    content: "危機対応後経営安定資金（セーフティネット貸付）のご案内\nコロナ融資等の既往債務の返済負担軽減に。経営者保証免除特例も併用可能です。",
    contentEn: "Safety-net Loan (Crisis Management Stabilization Fund)\nRelieve the burden of existing COVID-era loans. Personal guarantee exemption also available.",
    date: "2026/01",
    link: "/plans/safety-net",
    keywords: ["融資", "セーフティネット", "資金繰り", "経営安定", "危機対応", "神戸", "兵庫"]
  },
  {
    id: 2,
    content: "小規模事業者持続化補助金（第19回公募）\n2026年4月30日締切予定。通常枠50万円、インボイス特例・賃金引上げ特例で上乗せあり",
    contentEn: "Sustainability Grant for Micro-Businesses (19th round)\nDeadline: approx. April 30, 2026. Standard cap ¥500K; invoice & wage-raise exceptions available.",
    date: "2026/01",
    link: "https://r6.jizokukahojokin.info/",
    keywords: ["補助金", "小規模持続化補助金", "神戸", "兵庫"]
  },
  {
    id: 6,
    content: "中小企業省力化投資補助金（第5回公募・一般型）\n2026年2月受付開始。人手不足解消のための省力化設備導入を支援。最大8,000万円、補助率1/2〜2/3",
    contentEn: "SME Labor-Saving Investment Subsidy (5th round, General)\nApplications open Feb 2026. Up to ¥80M, subsidy rate 1/2–2/3.",
    date: "2026/01",
    link: "https://shoryokuka.smrj.go.jp/ippan/",
    keywords: ["補助金", "省力化投資", "生産性向上", "神戸", "兵庫"]
  },
  {
    id: 8,
    content: "ものづくり補助金（第22次締切）\n2026年1月30日締切。製品・サービス高付加価値化枠、最大4,000万円、補助率1/2〜2/3",
    contentEn: "Monozukuri (Manufacturing) Subsidy (22nd deadline)\nDeadline: Jan 30, 2026. High-value product/service track, up to ¥40M, subsidy rate 1/2–2/3.",
    date: "2026/01",
    link: "https://portal.monodukuri-hojo.jp/",
    keywords: ["補助金", "ものづくり", "生産性向上", "神戸", "兵庫"]
  },
  {
    id: 9,
    content: "デジタル化・AI導入補助金2026（旧IT導入補助金）\n2026年3月下旬公募開始予定。AI・デジタル化によるITツール導入を支援。補助率1/2〜2/3",
    contentEn: "Digitalization & AI Subsidy 2026 (formerly IT Introduction Subsidy)\nApplications expected late March 2026. Supports AI/digital tool adoption, subsidy rate 1/2–2/3.",
    date: "2026/01",
    link: "https://it-shien.smrj.go.jp/",
    keywords: ["補助金", "IT導入", "AI", "業務効率化", "DX", "神戸", "兵庫"]
  },
  {
    id: 11,
    content: "人材開発支援助成金（リスキリング支援コース）\n従業員のDX・AI等リスキリング訓練経費を最大75%助成（中小企業）。上限50万円/人。※申請には認定経営革新等支援機関の確認書が必要です",
    contentEn: "Human Resources Development Subsidy (Reskilling Course)\nUp to 75% of reskilling training costs covered (SMEs), max ¥500K/person. Note: requires confirmation from a Certified Business Support Agency.",
    date: "2026/03",
    link: "https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/koyou_roudou/koyou/kyufukin/d01-1.html",
    keywords: ["助成金", "リスキリング", "人材開発", "DX", "研修", "神戸", "兵庫"]
  },
  {
    id: 3,
    content: "経営者保証に関するガイドラインの活用で保証なし融資が過半数に\n保証料上乗せで経営者保証不要の信用保証制度も利用可能（2027年3月末まで補助あり）",
    contentEn: "Personal Guarantee Guidelines for Business Owners\nGuarantee-free loans now available for majority of cases. Credit guarantee scheme with premium surcharge also usable (subsidy available until March 2027).",
    date: "2026/01",
    link: "/plans/keieisha-hosho",
    keywords: ["融資", "経営者保証", "ガイドライン", "神戸", "兵庫"]
  }
];
